import { WorksheetChecklistItem } from '../../../types/worksheet-checklist-item';
import ChecklistItem from './ChecklistItem';

type ChecklistItemsProps = {
    items: WorksheetChecklistItem[];
    worksheetId: string;
    compactView?: boolean;
};
function ChecklistItems({ items, worksheetId, compactView = false }: ChecklistItemsProps): JSX.Element {
    return (
        <div className="flex flex-col gap-2 mb-4">
            {items
                .sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
                .map((item) => {
                    return <ChecklistItem key={item.id} item={item} worksheetId={worksheetId} compactView={compactView} />;
                })}
        </div>
    );
}

export default ChecklistItems;
